var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgShareL(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 594,
    viewBox: "0 0 291 594",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.261 509.4L78 382.761L179.467 334L263.344 464.2L203.177 534.919L104.261 509.4Z",
    fill: "#11405D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M211.551 1C211.551 1 155.291 24.5224 174.721 35.122C194.151 45.7216 196.616 27.4264 184.291 28.0072C171.966 28.588 156.451 61.4032 165.731 62.71C175.011 64.0168 175.301 53.1268 168.486 53.1268C161.671 53.1268 154.421 56.3212 157.901 67.792",
    stroke: "#FD612E",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.32458 599.301H212L-8 379C-8 379 -4.19081 598.166 -5.32458 599.301Z",
    fill: "#FCC75F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.876 496.03L132.962 494.053C137.592 485.774 135.928 476.887 128.517 470.278C118.151 461.036 98.2751 457.369 73.9769 460.216C61.9174 461.629 53.1799 459.836 48.0062 454.889C41.4205 448.59 41.3321 437.497 47.7433 421.918C50.7341 414.762 54.4481 407.771 58.856 401L65.5651 403.311C65.486 403.425 59.2841 412.726 54.8641 423.486C52.3052 429.718 50.842 435.201 50.5163 439.784C50.1348 445.133 51.3002 449.141 53.9755 451.698C57.3998 454.974 63.5528 456.041 72.7836 454.959C86.9111 453.304 99.5848 453.637 110.451 455.958C120.375 458.07 128.633 461.872 134.328 466.944C143.438 475.071 145.513 485.944 139.876 496.03ZM65.5651 403.311L62.2106 402.155L65.5651 403.309V403.311Z",
    fill: "#FD612E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53 290.824L133 205L123.316 418.909L53 290.824Z",
    fill: "#79B473"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M150 162C150 162 168.824 213.565 219.708 198.832C270.592 184.099 254.121 167.051 229.12 171.05C204.119 175.049 197.06 254.396 251.18 245.767C305.299 237.137 297.211 208.392 261.257 216.029C225.303 223.667 227.65 262.815 267.063 266.393",
    stroke: "#FD612E",
    strokeWidth: 1.36,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M143 54.0552C154.046 54.0552 163 45.0885 163 34.0276C163 22.9667 154.046 14 143 14C131.954 14 123 22.9667 123 34.0276C123 45.0885 131.954 54.0552 143 54.0552Z",
    fill: "#11405D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5 175.302C75.0899 175.302 78 173.22 78 170.651C78 168.082 75.0899 166 71.5 166C67.9101 166 65 168.082 65 170.651C65 173.22 67.9101 175.302 71.5 175.302Z",
    fill: "#11405D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgShareL);
export default __webpack_public_path__ + "static/media/bg-share-l.0b3f6517165770294c9754d428039643.svg";
export { ForwardRef as ReactComponent };